import { Divider, Stack, Typography } from '@mui/material';
import useFlexBoxStyles from 'common/flexBox';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
    return {
        navLine: {
            background: theme.palette.secondary.medium,
            top: '13px',
            [theme.breakpoints.up('xl')]: {
                top: '16px',
            },
        },

        navButton: {
            background: theme.palette.background.paper,
            border: `1px solid ${theme.palette.secondary.medium}`,
            color: '#6E6E6E',
            height: theme.spacing(3),
            padding: theme.spacing(0, 1.5),
            [theme.breakpoints.up('xl')]: {
                padding: theme.spacing(0, 2),
                height: theme.spacing(4),
            },
            [theme.breakpoints.down('lg')]: {
                padding: theme.spacing(0, 1.5),
                height: theme.spacing(3),
            },
            [theme.breakpoints.down('ms')]: {
                padding: theme.spacing(0, 1.25),
                height: theme.spacing(2.75),
            },
        },

        navActive: {
            borderWidth: '2px',
            color: '#000000',
            borderColor: '#000',
        },
    };
});

const FormNav = (props) => {
    const { step, setStep, steps, wizardMode } = props;
    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();

    return (
        <Stack direction="row" justifyContent="space-between" className={flexBox.relative}>
            <Divider className={cx(flexBox.absolute, flexBox.zIndex1, flexBox.w100, classes.navLine)} />
            {steps.map((mapStep, mapIndex) => {
                const index = mapIndex + 1;
                const active = step === index ? classes.navActive : '';
                const blockedClass = wizardMode && step < index ? 'cursorNotAllowed' : false;
                const blocked = wizardMode && step < index;

                return mapStep ? (
                    <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        aria-hidden={true}
                        key={mapStep}
                        className={cx(
                            flexBox.zIndex2,
                            flexBox.borderRadius2,
                            flexBox.cursorPointer,
                            classes.navButton,
                            active,
                            blockedClass,
                        )}
                        onClick={() => !blocked && setStep(index)}
                    >
                        <Typography textAlign="center" variant="subtitle2" fontWeight={active ? 'bold' : 400}>
                            {mapStep.toUpperCase()}
                        </Typography>
                    </Stack>
                ) : null;
            })}
        </Stack>
    );
};

export default FormNav;
